import PNotify from 'pnotify/dist/pnotify.js'
import 'pnotify/dist/pnotify.animate.js'
import 'pnotify/dist/pnotify.buttons.js'
import 'pnotify/dist/pnotify.callbacks.js'
import 'pnotify/dist/pnotify.confirm.js'
import 'pnotify/dist/pnotify.desktop.js'
import 'pnotify/dist/pnotify.history.js'
import 'pnotify/dist/pnotify.mobile.js'


'use strict';


var ad_notification = function () {
  var self = this;

  self.init();
};


ad_notification.prototype.init = function () {
  var self = this;

  // console.log('init ad_notification');

  self.instances = [];

  self.INSTANCES_POOL = {};
  self.INSTANCES_COUNTER = 0;

  // Definimos un nuevo theme siguiendo un ejemplo de la página de github
  PNotify.styling.material = {
      // Material doesn't require any UI libraries.
      container: 'pnotify-material',
      notice: 'pnotify-material-notice',
      notice_icon: 'material-icons pnotify-material-icon-notice',
      info: 'pnotify-material-info',
      info_icon: 'material-icons pnotify-material-icon-info',
      success: 'pnotify-material-success',
      success_icon: 'material-icons pnotify-material-icon-success',
      error: 'pnotify-material-error',
      error_icon: 'material-icons pnotify-material-icon-error',
      closer: 'pnotify-material-icon-closer',
      pin_up: 'pnotify-material-icon-sticker',
      pin_down: 'pnotify-material-icon-sticker pnotify-material-icon-stuck'
  };

  PNotify.prototype.options.styling = 'material';

};

ad_notification.prototype.init_notification = function (html_element, text_html, update, instance) {
  var self = this;

  var element = jQuery(html_element);

  var title = PNotify.prototype.options.title;
  if (html_element.hasAttribute('data-title') ) {
    title = element.attr('data-title');
  }

  var text = PNotify.prototype.options.text;
  if (text_html === undefined) {
    if (html_element.hasAttribute('data-text') ) {
      text = element.attr('data-text');
    }
  } else {
    text = text_html;
  }

  var type = PNotify.prototype.options.type;
  if (html_element.hasAttribute('data-type') ) {
    type = element.attr('data-type');
  }

  var width = PNotify.prototype.options.width;
  if (html_element.hasAttribute('data-width') ) {
    width = element.attr('data-width');
  }

  var min_height = PNotify.prototype.options.min_height;
  if (html_element.hasAttribute('data-min-height') ) {
    min_height = element.attr('data-min-height');
  }

  var hide = PNotify.prototype.options.hide;
  if (html_element.hasAttribute('data-hide') ) {

    if ( element.attr('data-hide') === 'false' ) {
      hide = false;
    } else if ( element.attr('data-hide') === 'true' ) {
      hide = true;
    }

  }

  var buttons = {
    sticker: false,
    closer_hover: false,
    closer: true
  };

  if (html_element.hasAttribute('data-buttons-closer') ) {
    if ( element.attr('data-buttons-closer') === 'false' ) {
      buttons.closer = false;
    } else if ( element.attr('data-buttons-closer') === 'true' ) {
      buttons.closer = true;
    }
  }



  var mobile = PNotify.prototype.options.mobile;
  if (html_element.hasAttribute('data-mobile-swipe-dismiss') ) {

    if ( element.attr('data-mobile-swipe-dismiss') === 'false' ) {
      mobile.swipe_dismiss = false;
    } else if ( element.attr('data-mobile-swipe-dismiss') === 'true' ) {
      mobile.swipe_dismiss = true;
    }

  }


  var delay = PNotify.prototype.options.delay;
  if (html_element.hasAttribute('data-delay') ) {
    delay = parseInt(element.attr('data-delay'));
  }


  var stack = PNotify.prototype.options.stack;
  var is_modal = false;

  if (html_element.hasAttribute('data-modal') ) {
    if ( element.attr('data-modal') === 'false' ) {
      is_modal = false;
    } else if ( element.attr('data-modal') === 'true' ) {

      is_modal = true;
    }
  } else {
    is_modal = false;
  }

  if (is_modal) {
    stack = {
      'dir1': 'down',
      'dir2': 'right',
      'push': 'top',
      'modal': true,
      'overlay_close': false/*,
      context: jQuery('#ad_notification_el_context')*/
    };
  } else {
    //stack.context = jQuery('#ad_notification_el_context');
  }

  // if (removeAll) {
  // PNotify.removeAll();  
  // }







  var check_overflow = false;
  var active = false;
  var has_ruby_id = false;
  var ruby_id = null;

  if (html_element.hasAttribute('data-no-overflow') ) {
    if ( element.attr('data-no-overflow') === 'false' ) {
      check_overflow = false;
    } else if ( element.attr('data-no-overflow') === 'true' ) {
      check_overflow = true;
    }

  }

  if ( check_overflow ) {

    if (html_element.hasAttribute('id') ) {

      ruby_id = 'ad_notification_ruby_id_' + element.attr('id');
      has_ruby_id = true;

    }

    if ( has_ruby_id ) {

      if (jQuery('.' + ruby_id).length) {

        active = true;

        // console.log('Sí está activa la notificación');
      } else {
        
        active = false;

        // console.log('No está activa la notificación');
      }

    }

    if (active) {

      // Hacemos un update la anterior notificación
      // var update = true;

      // var notification_element = jQuery('.' + ruby_id)[0];

      // var instance = self.find_notification(notification_element);

    }

  }














  if (update) {

    instance.update({
      title: title,
      text: text,
      type: type,
      hide: hide,
      width: width,
      min_height: min_height,
      mobile: mobile,
      // addclass: addclass,
      insert_brs: false,
      buttons: buttons,
      delay: delay
    });

    

  } else {
    self.INSTANCES_COUNTER = self.INSTANCES_COUNTER + 1;

    var instance_id = 'ad_notification_id_' + self.INSTANCES_COUNTER;
    var addclass = 'ad_notification_instance ' + instance_id;

    if ( is_modal ) {
      addclass = addclass + ' stack-modal';
    }

    if ( has_ruby_id ) {
      addclass = addclass + ' ' + ruby_id;
    }


    var notification = new PNotify({
      title: title,
      text: text,
      type: type,
      hide: hide,
      width: width,
      min_height: min_height,
      mobile: mobile,
      addclass: addclass,
      insert_brs: false,
      buttons: buttons,
      delay: delay,
      stack: stack
    });

    self.INSTANCES_POOL[instance_id] = notification;


/*********************************************************************/
//return notification;
/*********************************************************************/

  }




};

ad_notification.prototype.find_notification = function (html_element) {
  var self = this;

  var instance = null;

  for (var i = 0; i < html_element.classList.length; i++) {
    var current = html_element.classList[i];

    if ( current.includes('ad_notification_id_') ) {
      // console.log(current);
      instance = self.INSTANCES_POOL[current];
    }

  }

  return instance;

};

ad_notification.prototype.notification = function (html_element) {
  var self = this;

  self.init_notification(html_element);

};

ad_notification.prototype.html_selector = function (selector) {
  var self = this;

  var element = jQuery(selector);

  var text = element.html();

  self.init_notification(element[0], text);

};

ad_notification.prototype.update_html_selector = function (target, selector) {
  var self = this;

  var element = jQuery(selector);

  var text = element.html();

  var notification_element = jQuery(target).closest('.ad_notification_instance')[0];

  var ad_notification_instance = self.find_notification(notification_element);

  // Update notification
  self.init_notification(element[0], text, true, ad_notification_instance);

};

ad_notification.prototype.remove = function (target) {
  var self = this;

  var notification_element = jQuery(target).closest('.ad_notification_instance')[0];

  var ad_notification_instance = self.find_notification(notification_element);

  ad_notification_instance.remove();

};






jQuery( document ).ready(function() {

  window.ad_notification = new ad_notification();

});



